import app from '../../forum/app';
import Component from '../../common/Component';
import humanTime from '../../common/helpers/humanTime';
import fullTime from '../../common/helpers/fullTime';
import Post from '../../common/models/Post';
import classList from '../../common/utils/classList';
/**
 * The `PostMeta` component displays the time of a post, and when clicked, shows
 * a dropdown containing more information about the post (number, full time,
 * permalink).
 */
export default class PostMeta extends Component {
  view() {
    const post = this.attrs.post;
    const time = post.createdAt();
    const permalink = this.getPermalink(post);
    const touch = 'ontouchstart' in document.documentElement;

    // When the dropdown menu is shown, select the contents of the permalink
    // input so that the user can quickly copy the URL.
    const selectPermalink = function (e) {
      setTimeout(() => $(this).parent().find('.PostMeta-permalink').select());
      e.redraw = false;
    };
    return m("div", {
      className: "Dropdown PostMeta"
    }, m("button", {
      className: classList({
        'Button Button--text': true,
        'Dropdown-toggle Button--link': !!permalink
      }),
      onclick: permalink ? selectPermalink : undefined,
      "data-toggle": "dropdown"
    }, humanTime(time)), !!permalink && m("div", {
      className: "Dropdown-menu dropdown-menu"
    }, m("span", {
      className: "PostMeta-number"
    }, this.postIdentifier(post)), " ", m("span", {
      className: "PostMeta-time"
    }, fullTime(time)), ' ', m("span", {
      className: "PostMeta-ip"
    }, post.data.attributes.ipAddress), touch ? m("a", {
      className: "Button PostMeta-permalink",
      href: permalink
    }, permalink) : m("input", {
      className: "FormControl PostMeta-permalink",
      value: permalink,
      onclick: e => e.stopPropagation()
    })));
  }

  /**
   * Get the permalink for the given post.
   */
  getPermalink(post) {
    if (post instanceof Post) {
      return app.forum.attribute('baseOrigin') + app.route.post(post);
    }
    return this.attrs.permalink?.() || null;
  }
  postIdentifier(post) {
    if (post instanceof Post) {
      return app.translator.trans('core.forum.post.number_tooltip', {
        number: post.number()
      }, true);
    }
    return null;
  }
}
flarum.reg.add('core', 'forum/components/PostMeta', PostMeta);